import React, { useContext } from "react";
import TabPanel from "@/components/TabPanel/TabPanel";
import SummaryCaseDetails from "@/pages/CaseDetail/Summary/SummaryCaseDetails/SummaryCaseDetails";
import DebtorTabContent from "@/features/debtor/debtorTab/DebtorTabContent";
import CreditorTabContent from "@/features/creditor/creditorsTab/creditorTabContent";
import ClaimsTabContent from "@/features/claims/claimsTab/claimsTabContent";
import Configuration from "@/pages/CaseDetail/Configuration/Configuration";
import Voting from "@/pages/CaseDetail/Voting/Voting";
import Distributions from "@/pages/CaseDetail/Distributions/Distributions";
import ImportAndExport from "@/pages/CaseDetail/Import&Export/ImportandExport";
// import PortalConfiguration from "@/pages/CaseDetail/PortalConfiguration/PortalConfiguration";
import PaymentStatus from "@/pages/CaseDetail/PaymentStatus/PaymentStatus";
import Reporting from "@/pages/CaseDetail/Reporting/Reporting";
import CaseContext from "@/pages/CaseDetail/CaseContext";
import Tasks from "@/pages/CaseDetail/Tasks/Tasks";
// import SubmissionManagement from "@/pages/CaseDetail/SubmissionManagement/SubmissionManagement";

interface DefinedTabPanelProps {
  defaultActiveKey?: number;
}
interface BannerData {
  debtorId: string;
  caseId: string;
  name: string;
  description: string;
  createdBy: string;
  updatedBy: string;
  isActive: boolean;
}

const bannerData: BannerData = {
  debtorId: "d05e52a1-6b55-4ad2-9c34-f5aaadd806fb",
  caseId: "536be3c1-f9b0-4c4d-b530-e516d75f347e",
  name: "Anjana Dharmasiri",
  description: "Test Anjana ",
  createdBy: "CA013334848",
  updatedBy: "CA013334848",
  isActive: true,
};
const bannerDataArray: BannerData[] = [bannerData];

const tabPanelData = {
  title: [
    "pages.caseOverView.tabPannelDetails.summaryLabel",
    "pages.caseOverView.tabPannelDetails.creditorsLabel",
    "pages.caseOverView.tabPannelDetails.claimsLabel",
    "pages.caseOverView.tabPannelDetails.votingLabel",
    "pages.caseOverView.tabPannelDetails.distributionsLabel",
    "pages.caseOverView.tabPannelDetails.paymentStatusLabel",
    "pages.caseOverView.tabPannelDetails.configurationLabel",
    "pages.caseOverView.tabPannelDetails.debtorsLabel",
    "pages.caseOverView.tabPannelDetails.reportingLabel",
    "pages.caseOverView.tabPannelDetails.importHistoryLabel",
    "pages.caseOverView.tabPannelDetails.taskLabel",
    // "pages.caseOverView.tabPannelDetails.portalConfigurationLabel",
    // "pages.caseOverView.tabPannelDetails.submissionManagement",
  ],
  content: [
    <SummaryCaseDetails />,
    <CreditorTabContent />,
    <ClaimsTabContent />,
    <div>
      <Voting />
    </div>,
    <Distributions />,
    <PaymentStatus />,
    <Configuration />,
    <DebtorTabContent bannerData={bannerDataArray} />,
    <Reporting />,
    <ImportAndExport />,
    <Tasks />,
    // <PortalConfiguration />,
    // <SubmissionManagement />,
  ],
};

const DefinedTabPanel: React.FC<DefinedTabPanelProps> = ({
  defaultActiveKey,
}) => {
  const caseContextData: any = useContext<any>(CaseContext);
  if (defaultActiveKey && defaultActiveKey > 0) {
    caseContextData.setEditCase(false);
  }
  return (
    <>
      <div className="ccwp_table_wrapper ccwp_table_dropdown_wrapper">
        <TabPanel data={tabPanelData} defaultActiveKey={defaultActiveKey} />
      </div>
    </>
  );
};

export default DefinedTabPanel;
